// extracted by mini-css-extract-plugin
module.exports = {"root":"KioskRefill_root__2PHm2","remainValues":"KioskRefill_remainValues__1gv51","input":"KioskRefill_input__3E2o9","unit":"KioskRefill_unit__KXS0p"};